<template>
  <div>
    <div class="container text-left">
      <div
        v-if="paginationMeta"
        class="mt-3 mb-2"
      >
        <span v-if="this.$route.query.provinces != '' && this.$route.query.provinces != undefined">{{ $t('pages.public-offers.search-location-status', { total: paginationMeta.total, place: translateProvinces(this.$route.query.provinces) }) }}</span>
        <span v-else-if="this.$route.query.keyword != '' && this.$route.query.keyword != undefined">{{ $t('pages.public-offers.search-keyword-status', { total: paginationMeta.total, phrase: this.$route.query.keyword || "" }) }}</span>
        <span v-else>{{ $t('pages.public-offers.search-status', { total: paginationMeta.total }) }}</span>
      </div>
      <div
        v-if="!paginationMeta"
        class="mt-3 mb-2"
        style="min-height: 24px;"
      />
      <div class="row text-left">
        <div class="col-12 col-lg-3">
          <Filters
            ref="filters"
            class="mb-3"
          />
        </div>
        <div class="col-12 col-lg-9">
          <!-- <div class="col-12 col-md-12"> -->
          <b-overlay
            :show="isOffersLoading"
            rounded="sm"
          >
            <div
              v-if="(results && results.length === 0) || init"
              class="no-offers-card text-center"
              style="padding: 90px"
            >
              <div class="mb-2">
                {{ $t('pages.public-offers.no-offers') }}
              </div>
              <a
                href="#"
                @click="$refs.filters.resetFilters()"
              >
                <strong>{{ $t('pages.public-offers.view-all-offers') }}</strong>
              </a>
            </div>
            <div
              v-for="offer in results"
              :key="offer.id"
            >
              <OfferCard
                v-if="!offer.isArchived"
                :offer="offer"
              />
            </div>
            <pagination
              v-if="paginationMeta"
              :data="paginationMeta"
              size="small"
              :limit="1"
              align="center"
              @pagination-change-page="getResults"
            />
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from '@/components/Home/OfferCard';
import Filters from '@/components/Home/Filters';

export default {
  components: {
    OfferCard,
    Filters,
  },
  data() {
    return {
      results: "",
      paginationMeta: null,
      initialSearch: null,
      init: true,
      isOffersLoading: false
    }
  },
  watch: {
    // call again the method if the route changes
    '$route': 'doSearch'
  },
  mounted() {
    this.results = this.$route.params.results;
    this.initialSearch = setTimeout(() => {
      this.doSearch();
    }, 15);
  },
  methods: {
    getQueryParams() {
      const commonQueryParams = {};
      const searchParams = [
        'place',
        'keyword',
        'maxOfferAge',
        'minSalary',
        'salaryMode',
        'provinces',
        'contractTypes',
        'contractWorkdays',
        'expMin',
        'expMax',
        'categories',
        'minStudies',
        'page',
      ];

      // ------------------
      // Fill in query if filters are actually selected
      for (let param of searchParams) {
        commonQueryParams[param] = this.$route.query[param];
      }

      return commonQueryParams;
    },

    doSearch() {
      this.isOffersLoading = true;
      if (this.initialSearch) {
        clearTimeout(this.initialSearch);
      }
      const queryParams = this.getQueryParams();
      this.axios.post('/offer/search', { keyword: this.$route.query.keyword, ...queryParams })
      .then( response => {
        this.results = response.data.data;
        this.paginationMeta = response.data;
        this.init = false;
        this.isOffersLoading = false;
      })
    },

    getResults(page) {
      const queryParams = this.getQueryParams();
      this.$router.replace({ name: 'search-offers', query: { ...queryParams, page } });
      this.axios.post('/offer/search?page=' + page, { keyword: this.$route.query.keyword, ... queryParams })
        .then((res) => {
          this.paginationMeta = res.data;
          this.results = res.data.data;
          window.scrollTo(0,0);
        })
    },
    translateProvinces(provinces) {
      for(let i in provinces) {
        if(provinces[i] === "El extranjero") {
          provinces[i] = this.$t('generic.abroad', 'Abroad');
        } else if(provinces[i] === "Toda España") {
          provinces[i] = this.$t('generic.all-spain', 'All Spain');
        }
      }

      return provinces;
    },
  },
  metaInfo: {
      title: 'Buscar ofertas',
      titleTemplate: '%s - ' + process.env.VUE_APP_NAME,
      meta: [
          { vmid: "description", name: "description", content: "Search for offers in " + process.env.VUE_APP_NAME + " portal" },
          { vmid: "og:title", name: "og:title", content: "Buscar ofertas" },
          { vmid: "og:description", name: "og:description", content: "Search for offers in " + process.env.VUE_APP_NAME + " portal" },
      ]
  },
}
</script>

<style lang="scss" scoped>
  .no-offers-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
  }
</style>
